export const POLICY_LIST_STORE = 'POLICY_LIST_STORE';
export const POLICY_STORE = 'POLICY_STORE';
export const POLICY_FETCH_FAILED = 'POLICY_FETCH_FAILED';
export const SUBSIDIARY_LIST_STORE = 'SUBSIDIARY_LIST_STORE';
export const PLAN_LIST_STORE = 'PLAN_LIST_STORE';
export const RESET_STATE = 'POLICY_RESET_STATE';
export const STORE_POLICIES_FOR_UPDATE = 'STORE_POLICIES_FOR_UPDATE';
export const RESET_POLICIES_FOR_UPDATE = 'RESET_POLICIES_FOR_UPDATE';
export const REQUEST_LIST_STORE = 'REQUEST_LIST_STORE';
export const REQUEST_STORE = 'REQUEST_STORE';
